"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TogglerItem = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _bumaga = require("../tabs/bumaga.tabs");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _loadStyles = _interopRequireDefault(require("load-styles"));

// bumaga.tabs source file for @bumaga/tabs at https://www.npmjs.com/package/@bumaga/tabs
(0, _loadStyles.default)(".cd6149766{color:var(--color-flomni-gray-90);box-sizing:border-box;cursor:pointer;display:flex;align-items:center;justify-content:center;margin:0 .1875rem;transition:all var(--animation-timing-def) ease;transition-property:color,opacity}.cd6149766:hover{opacity:.7}.c702d4e60{height:2.125rem;width:2.125rem}.c8cb05955{font-size:.875rem;font-weight:400;line-height:1rem;padding:.5625rem}.c795e711d:hover{opacity:1}.c795e711d.c8ecfd159{color:var(--color-flomni-blue-70)}.c795e711d.cd28d3bcb{color:var(--color-flomni-green-70)}");
var styles = {
  root: 'cd6149766',
  '--type-icon': 'c702d4e60',
  '--type-text': 'c8cb05955',
  '--active': 'c795e711d',
  '--view-action': 'c8ecfd159',
  '--view-success': 'cd28d3bcb'
};

var TogglerItem = function TogglerItem(props) {
  var children = props.children,
      classes = props.classes,
      type = props.type,
      view = props.view;

  var _useTabState = (0, _bumaga.useTabState)(children),
      isActive = _useTabState.isActive,
      onClick = _useTabState.onClick;

  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClick,
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.active, isActive), cn.type[type], cn.view[view])
  }, children);
};

exports.TogglerItem = TogglerItem;
var type = ['icon', 'text'];
var view = ['action', 'success'];
TogglerItem.modes = {
  type: type,
  view: view
};
TogglerItem.propTypes = {
  children: _propTypes.node.isRequired,
  classes: (0, _getClassesPropType.getClassesPropType)(styles),
  type: (0, _propTypes.oneOf)(type),
  view: (0, _propTypes.oneOf)(view)
};
TogglerItem.defaultProps = {
  classes: {},
  type: 'icon',
  view: 'action'
};